<header-title [model]="headerTitle"></header-title>

<div class="container-fluid py-4" *ngIf="companyAuditModel">
    <div class="row row-cols-1 row-cols-lg-3 g-4">

      <div class="col col-12 col-lg-3">
        <div class="card">
          <div class="card-header d-flex align-items-center justify-content-between">
            <h4 class="card-title"><i class="fa fa-fw fa-tasks"></i>{{companyAuditModel.title}}</h4>
            <a href="#" class="float-end text-primary" data-bs-toggle="collapse" data-bs-target="#collapseCard1">
              <i class="fa fa-chevron-down"></i>
            </a>
          </div>
          <!-- Card body with a unique id and collapse class -->
          <div id="collapseCard1" class="collapse show">
            <div class="card-body">
              <div class="mb-3"><ul class="list-unstyled">
                <div class="bg-success bg-opacity-25 text-default mb-3" *ngIf="infoMessage">
                    <div class="card-body">{{infoMessageText}}</div>
                </div>
                <li class="d-flex justify-content-between py-2 border-bottom" *ngIf="availableCompaniesNr>1">
                    <label class="text-sm text-muted">Company</label> {{companyTitle}}
                </li>
                <li class="d-flex justify-content-between py-2 border-bottom">
                    <label class="text-sm text-muted">Audit Template</label> {{companyAuditModel.auditTemplateDescription}} <button class="btn btn-text bg-transparent text-primary" [routerLink]="['/company-audit','update',companyAuditModel.id]" *ngIf="companyAuditModel.auditStatus==0"><span class="fas fa-pencil-alt"></span></button>
                </li>
                <li class="d-flex justify-content-between py-2 border-bottom">
                    <label class="text-sm text-muted">Start</label> {{companyAuditModel.startDate | date: 'dd/MM/yyyy'}}
                </li>
                <li class="d-flex justify-content-between py-2 border-bottom">
                    <label class="text-sm text-muted">Deadline</label> {{companyAuditModel.deadlineDate | date: 'dd/MM/yyyy'}}
                </li>
                <li class="d-flex justify-content-between py-2 border-bottom">
                    <label class="text-sm text-muted">Status</label>
                    <span class="far fa-circle text-primary" *ngIf="companyAuditModel.auditStatus==0" data-toggle="tooltip" title="Open"></span>
                    <span class="fas fa-circle text-primary" *ngIf="companyAuditModel.auditStatus==1" data-toggle="tooltip" title="Completed"></span>
                </li>
                <li class="d-flex justify-content-between py-2 border-bottom" *ngIf="companyAuditModel.completedDate">
                    <label class="text-sm text-muted">Completed</label>
                    <span>{{companyAuditModel.completedDate | date: 'dd/MM/yyyy'}}</span>
                </li>
                <li class="d-flex justify-content-between py-2 border-bottom" *ngIf="companyAuditModel.auditStatus==1">
                    <label class="text-sm text-muted">Rating</label>
                    <span *ngIf="averageColour<1.5" data-toggle="tooltip" title="Positive - Well Done"><span class="fas fa-circle text-success"></span></span>
                    <span *ngIf="averageColour>=1.5&&averageColour<2.5" data-toggle="tooltip" title="OK - Needs Attention"><span class="fas fa-circle text-warning"></span></span>
                    <span *ngIf="averageColour>=2.5" data-toggle="tooltip" title="Poor - High Risk"><span class="fas fa-circle text-danger"></span></span>
                </li>
            </ul>
              </div>
            </div>
            <div class="card-footer border-0 bg-white pb-3">
                <button class="btn btn-primary w-100" (click)="downloadReport(companyAuditModel.auditCategoryId, companyAuditModel.id)" *ngIf="!reportDownloading && companyAuditModel.auditStatus==1"><i class="fa fa-file-pdf-o" aria-hidden="true"></i> {{reportDownloaded ? 'Report Downloaded' : 'Download Report'}}</button>
                <div class="card card-info" *ngIf="reportDownloading"><div class="card-body text-center"><p>PDF compile commenced</p><i class="fa fa-spin fa-spinner"></i></div></div>
            </div>
          </div>
        </div>
      </div>

      <div class="col col-12 col-lg-9">
        <div class="card mb-4">

          <div class="card-header d-flex align-items-center justify-content-between">
            <h4 class="card-title"><i class="fa fa-fw fa-cubes"></i>Modules</h4>
          </div>

          <div class="card-body py-3">
            <div class="available-modules-panel mb-5" *ngIf="selectableModules?.length>0 && companyAuditModel.auditStatus==0">
                <div class="container">
                    <div class="row available-modules-title py-2">
                        <div class="col-12"><h5 class="text-muted">Available Audit Modules</h5></div>
                    </div>
                    <div class="row available-modules bg-primary bg-opacity-25 mb-1" *ngFor="let m of selectableModules; index as i">
                        <div class="col-text col-6 p-3">{{m.name}}</div>
                        <div class="col-text col-5 text-right p-3"><span *ngIf="m.isSingular">One allowed per audit</span><span *ngIf="!m.isSingular">Add new Audit Module for review</span></div>
                        <div class="col-btn col-1 p-2"><button class="btn btn-text" (click)="showAddModule(m)"><span class="fas fa-plus"></span></button></div>
                    </div>
                </div>
                <div class="mt-4 add-module-form-panel bg-primary bg-opacity-25 pb-1" *ngIf="addModuleFormVisible && addAuditModuleFormGroup">
                    <form [formGroup]="addAuditModuleFormGroup">
                        <div class="container">
                            <div class="row py-3">
                                <div class="col-12 col">
                                    <h5 class="text-muted">Add new {{addModule.name}} for review</h5>
                                </div>
                            </div>
                        </div>
                        <div class="container mb-5">
                            <div class="row">
                                <div class="col-9 col">
                                    <div class="row">
                                        <div class="col-md-5">
                                            <div class="form-group">
                                                <label class="control-label">Customer Surname</label>
                                                <input type="text" id="customerSurname" name="customerSurname" class="form-control" formControlName="customerSurname" />
                                            </div>
                                        </div>
                                        <div class="col-md-5">
                                            <div class="form-group">
                                                <label class="control-label">Customer First Name</label>
                                                <input type="text" id="customerInitial" name="customerInitial" class="form-control" formControlName="customerInitial" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-3">
                                        <div class="col-md-5">
                                            <div class="form-group">
                                                <label class="control-label">Broker</label>
                                                <select id="brokerId" name="brokerId" class="form-select" formControlName="brokerId">
                                                    <option value="" disabled selected>Select</option>
                                                    <option *ngFor="let broker of brokersList" [value]="broker.id">{{broker.name}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-5">
                                            <div class="form-group">
                                                <label class="control-label">Lender</label>
                                                <select name="lenderId" class="form-select" formControlName="lenderId">
                                                    <option value="" disabled selected>Select</option>
                                                    <option *ngFor="let lender of lendersList" [value]="lender.id">{{ lender.name}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-3 col justify-content-end align-items-end">
                                    <div class="row h-100 justify-content-end align-items-end">
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label class="control-label text-info">&nbsp;</label>
                                                <button class="btn btn-block btn-warning" (click)="hideAddModule()" title="Cancel"><span class="fas fa-times"></span></button>
                                            </div>
                                        </div>
                                        <div class="col-md-8">
                                            <div class="form-group">
                                                <label class="control-label text-info">&nbsp;</label>
                                                <button type="button" class="btn w-100 btn-success" (click)="addModuleToAudit(addModule)">Add</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div class="selected-modules-panel mt-2">
                <div class="container">
                    <table class="table table-hover modules-table" *ngIf="selectedModules?.length>0">
                        <thead>
                            <tr>
                                <th>Selected Modules</th>
                                <th>Customer</th>
                                <th>Broker</th>
                                <th>Lender</th>
                                <th class="text-center">Status</th>
                                <th class="text-center">Rating</th>
                                <th class="text-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let m of selectedModules; index as i">
                                <td>
                                    {{m.moduleDescription}}
                                    <pre style="display:none;">{{m | json}}</pre>
                                </td>
                                <td>
                                    {{m.customerInitial}} {{m.customerSurname}}
                                </td>
                                <td>
                                    {{m.brokerName}}
                                </td>
                                <td>
                                    {{m.lenderName}}
                                </td>
                                <td class="text-center">
                                    <span class="far fa-circle text-primary" *ngIf="m.moduleStatus==0" data-toggle="tooltip" title="Not started"></span>
                                    <span class="fas fa-adjust text-primary" *ngIf="m.moduleStatus==1" data-toggle="tooltip" title="In progress"></span>
                                    <span class="fas fa-circle text-primary" *ngIf="m.moduleStatus==2" data-toggle="tooltip" title="Completed"></span>
                                </td>
                                <td class="text-center">
                                    <div *ngIf="m.moduleStatus==2">
                                        <span *ngIf="m.weightedScore/(m.nrQuestions*2)*100 < 25" data-toggle="tooltip" title="Positive - Well Done"><span class="fas fa-circle text-success"></span></span>
                                        <span *ngIf="m.weightedScore/(m.nrQuestions*2)*100 >= 25 && m.weightedScore/(m.nrQuestions*2)*100 <= 75" data-toggle="tooltip" title="OK - Needs Attention"><span class="fas fa-circle text-warning"></span></span>
                                        <span *ngIf="m.weightedScore/(m.nrQuestions*2)*100 > 75" data-toggle="tooltip" title="Poor - High Risk"><span class="fas fa-circle text-danger"></span></span>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <button class="btn btn-text mr-2" (click)="selectedModuleId=m.id; confirmation.showMessage();" title="Delete" data-toggle="tooltip" *ngIf="m.moduleStatus==0"><span class="fas fa-trash text-danger"></span></button>
                                    <button class="btn btn-text" [routerLink]="['/company-audit', 'audit', companyAuditModel.id, m.id]" title="Launch" data-toggle="tooltip" *ngIf="companyAuditModel.auditStatus!=1"><span class="fas fa-rocket text-primary"></span></button>
                                    <button class="btn btn-text" [routerLink]="['/company-audit', 'view', companyAuditModel.id, m.id]" title="View" data-toggle="tooltip" *ngIf="companyAuditModel.auditStatus==1"><span class="fas fa-eye text-primary"></span></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table table-hover modules-table" *ngIf="!selectedModules">
                        <thead>
                            <tr>
                                <th>Selected Modules</th>
                                <th>Status</th>
                                <th>Rating</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colspan="4" class="text-warning">No Modules have been assigned to this audit. Add the required Modules to begin.</td>
                            </tr>
                        </tbody>
                    </table>
                    <div *ngIf="allowCloseAudit && companyAuditModel.auditStatus==0" class="text-end">
                        <button class="btn btn-success" (click)="closeAudit()">Close Audit</button>
                    </div>

                    <div *ngIf="companyAuditModel.auditStatus==1 && allowComments">
                        <form [formGroup]="addAuditSummaryForm" (submit)="updateAuditSummary()">
                            <error-message [errors]="errors"></error-message>
                            <div class="row mt-5">
                                <div class="col-12 col-md-6">
                                    <h5 class="text-muted">Audit Feedback</h5>
                                </div>
                                <div class="col-12 col-md-6 text-end">
                                    <button class="btn btn-primary btn-sm" type="button" (click)="toggleEditMode()" *ngIf="!isEditMode">Add Comment</button>
                                </div>
                            </div>
                            <hr/>
                            <div class="row mt-3" *ngFor="let x of auditComments">
                                <div class="col-8">{{x.comment}}</div>
                                <div class="col-2">{{x.siteUserName}}</div>
                                <div class="col-2 text-end">{{x.updatedDate | date: 'dd/MM/yyyy'}}</div>
                            </div>
                            <div class="row mt-3" *ngIf="isEditMode">
                                <div class="col-12">
                                    <div class="form-group">
                                        <input type="hidden" class="form-control" formControlName="companyAuditId" />
                                        <input type="hidden" class="form-control" formControlName="siteUserId" />
                                        <label class="control-label">
                                            Enter comments or feedback for this Audit.
                                        </label>
                                        <textarea class="form-control" formControlName="comment" [readOnly]="!isEditMode"></textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-12 text-end">
                                    <button class="btn btn-outline-primary ms-3" type="button" (click)="toggleEditMode()" *ngIf="isEditMode">Cancel</button>
                                    <button class="btn btn-success ms-3" type="submit" [disabled]="!addAuditSummaryForm.valid" *ngIf="isEditMode">Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>


          </div>
        </div>

      </div>

    </div>
  </div>


<app-confirmation-message #confirmation (confirmationClicked)="removeModuleFromAudit();"
                          [title]="'Confirmation'"
                          [message]="'Are you sure you want to remove this module?'">
</app-confirmation-message>
